export class CheckboxItem {
    value: string;
    initialValue: string;
    label: string;
    checked: boolean;
    changed: boolean;

    constructor(value: any, label: any, checked?: boolean) {
        this.value = value;
        this.initialValue = value;
        this.label = label;
        this.changed = false;
        this.checked = checked ? checked : false;
    }
}
